export default "__VITE_ASSET__DrPZpNwk__"